/* ------------------------------------------ SIMPLE MODAL - Chris 17.05.2016 ----------------------------------------- */
(function (jQuery) {
  jQuery.gfModal = function (element, options) {
    const defaults = {
      opacity: 0.3,
      bg: 'rgb(25, 25, 25)',
      zIndex: 999999,
      showOverlay: true,
      clickToHide: true,
      onCancel: function () {},
      onResume: function () {},
      onOverlayClick: function () {},
    };
    this.settings = {};
    const _this = this;
    var $element = jQuery(element),
      element = element;

    let _currentZindex;
    const _mdLoading = '<div class="modal-loading"><div class="progess"><div class="progess-stt"></div></div></div>';

    let $overlay;

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      _currentZindex = _this.settings.zIndex;
    };

    this.show = function () {
      if (_this.settings.showOverlay) {
        _this.createOverlay();
      }
      // $element.addClass('md-fadeIn md-show');
      $element.addClass('md-show');
      this.settings.onResume();

      setTimeout(function () {
        // Neu popup co class md-draggble to apply draggable plugin.
        $element.gfModalDraggable({
          handle: '.md-modal-handle',
        });
        // $element.find('input, select, textarea').gfForm();
        $element.gfForm({
          checkRequires: false,
        });
      }, 100);

      $element
        .find('.btnCancel, .btnClose')
        .off()
        .on('click', function () {
          _this.hide();
          return false;
        });

      return false;
    };

    this.hide = function () {
      $overlay.css({
        opacity: 0,
      });

      $element.removeClass('md-show');
      $overlay.remove();

      _this.settings.onCancel();

      $element.data('gfmodal', null);

      return false;
    };

    this.createOverlay = function () {
      _currentZindex++;
      const opacity = parseFloat(_this.settings.opacity);

      $overlay = jQuery('<div class="md-overlay" id="md-overlay-' + $element.attr('id') + '"></div>').appendTo('body');
      $overlay
        .css({
          'z-index': _currentZindex,
          opacity: opacity,
          'background-color': _this.settings.bg,
        })
        .show();

      $element.css('z-index', _currentZindex + 1);

      if (_this.settings.clickToHide) {
        $overlay.off().on('click', function () {
          _this.hide();
          _this.settings.onOverlayClick();
        });
      }
    };

    this.showLoading = function () {
      $element.find('.md-content .md-body .modal-loading').remove();
      const $mdLoading = jQuery(_mdLoading);
      $element.find('.md-content .md-body').append($mdLoading);
      $mdLoading.children('.progess').addClass('start');
    };

    this.hideLoading = function (a) {
      const $mdLoading = $element.find('.md-content .md-body .modal-loading');
      $mdLoading.children('.progess').addClass('done').removeClass('start');
      setTimeout(function () {
        $element.find('.md-content .md-body .modal-loading').remove();
        if (a === true) {
          setTimeout(function () {
            _this.hide();
          }, 200);
        }
      }, 500);
    };

    this.setTitle = function (title) {
      const $title = $element.find('[gf-tag="type"]');
      $title.html(title);
      return _this;
    };

    this.setWidth = function (width) {
      $element.find('.md-content').css('width', width);
      return _this;
    };

    this.setHeight = function (height) {
      $element.find('.md-content').css('height', height);
      return _this;
    };

    this.setPosition = function (left, top) {
      $element.css({
        left: left,
        top: top,
      });
      return _this;
    };

    this.centerModal = function () {
      const mw = parseInt($element.outerWidth());
      const mh = parseInt($element.outerHeight());

      // console.log({
      //     window: {
      //         width: jQuery(window).width(),
      //         height: jQuery(window).height()
      //     },
      //     modal: {
      //         width: mw,
      //         height: mh
      //     },
      //     $element,
      //     rect: $element.get(0).getBoundingClientRect()
      // })

      $element.css('left', (jQuery(window).width() - mw) / 2 + 'px');
      $element.css('top', (jQuery(window).height() - mh) / 2 + 'px');
      return _this;
    };
    this.init();
  };
  jQuery.fn.gfModal = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfmodal')) {
        const plugin = new jQuery.gfModal(this, options);
        jQuery(this).data('gfmodal', plugin);
      }
    });
  };
})(jQuery);
